import React from "react";
import "../styles/modal.css";
import FrmLogin from "../forms/FrmLogin";
import FrmAlertas from "../forms/FrmAlertas";
import FrmNewUser from "../forms/FrmNewUser";
import FrmEncuestas from "../forms/FrmEncuestas";
import FrmFotoPerfil from "../forms/FrmFotoPerfil";
import { saveAlerta } from "../requests/req_alertas";
import FrmRecordVideo from "../forms/FrmRecordVideo";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import PropagateLoader from "react-spinners/PropagateLoader";

import { saveFoto, getPerfil } from "../requests/req_perfil";
import { loginAuth } from "../requests/req_menu";
import {
  GuardarRespuestasInicialesCandidato,
  postPostularCandidato,
} from "../requests/req_ofertas";
import { notifica, amb, getUser } from "../requests/utils";
import Wizard from "./Wizard";
import Loader from "react-loader-spinner";
const sleep = (milliseconds) => {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
};
export default class Modalform extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: this.props.modal != null ? this.props.modal : false,
      idSolicitud: this.props.idSolicitud,
      idSolicitudActual: 0,
      preguntas: this.props.datasource != null ? this.props.datasource : [],
      optionSelected: [],
      isVisible: false,
    };
    this.toggle = this.toggle.bind(this);
    this.saveData = this.saveData.bind(this);
    this.saveResult = this.saveResult.bind(this);
    this.asignarfoto = this.asignarfoto.bind(this);
    this.ActionResult = this.ActionResult.bind(this);
    this.validaLogin = this.validaLogin.bind(this);
    this.onChange = this.onChange.bind(this);
    this.PostularPreguntas = this.PostularPreguntas.bind(this);
    this.postularse = this.postularse.bind(this);
  }
  onChange(selectedOption, _this) {
    _this.setState({ selectedOption, isvalid: true, isDisplay: false });
    var arr = this.state.optionSelected.filter(
      (x) => x.idPregunta != selectedOption.value.idPregunta
    );
    arr.push(selectedOption.value);
    this.setState({ optionSelected: arr });
    return true;
  }
  //Función que cambia el estatus del modal
  toggle(data) {
    if (data === 1000) {
      return this.setState({ isVisible: false });
    }
    this.setState({ isVisible: false });
    this.setState({ modal: !this.state.modal });
    if (this.state.modal) {
      if (this.props.cerrar != null) this.props.cerrar();
      //pppg
      var exit = document.getElementById("exit");
      if (exit) exit.click();
      this.setState({ idSolicitudActual: 0 });
    }
    if (data == null) return;
    if (data.code === 0) {
      getPerfil((p) => this.asignarfoto(p));
    }
  }
  asignarfoto(data) {
    var Item = data.data;
    localStorage.removeItem("foto");
    localStorage.setItem(
      "foto",
      Item[0].Tabla2[0].foto !== ""
        ? Item[0].Tabla2[0].foto
        : process.env.PUBLIC_URL + "/images/default-avatar.png"
    );
    var imgperfil = document.getElementById("img_ft_prfl");
    var imgMenu = document.getElementById("img_header");
    if (imgperfil)
      imgperfil.src =
        Item[0].Tabla2[0].foto !== ""
          ? Item[0].Tabla2[0].foto
          : process.env.PUBLIC_URL + "/images/default-avatar.png";
    if (imgMenu)
      imgMenu.src =
        Item[0].Tabla2[0].foto !== ""
          ? Item[0].Tabla2[0].foto
          : process.env.PUBLIC_URL + "/images/default-avatar.png";
  }
  componentDidMount() {
    let idSolicitudActual = this.state.idSolicitudActual;
    if (idSolicitudActual !== this.props.idSolicitud) {
      this.setState({ idSolicitudActual: this.props.idSolicitud });
    }
  }

  saveData(e) {
    switch (this.props.modulo) {
      case "Alertas":
        var PalClav = document.getElementById("palabraClave").value;
        var IdCat = document.getElementById("idCategoria").value;
        var IdEst = document.getElementById("idEstado").value;
        var IdSalMin = document.getElementById("salarioMinimo").value;

        let flag = true;
        if (PalClav === "") {
          notifica("warning", "La Palabra Clave no puede estar Vacia", "");
          return;
        }
        if (parseInt(IdCat) === 0) {
          notifica("warning", "Ingresa una Categoria Valida", "");
          return;
        }

        if (parseInt(IdEst) === 0) {
          notifica("warning", "Ingresa un Estado Valido", "");
          return;
        }
        if (IdSalMin === "") {
          notifica("warning", "Ingresa una cantidad en Salario Minimo", "");
          return;
        }

        let alertas = this.props.datos;
        if (alertas !== null) {
          const found = alertas.some((r) => PalClav === r.palabraClave);
          if (found)
            return notifica(
              "warning",
              "La palabra clave no puede ser igual a otra alerta",
              ""
            );
        }

        if (flag === true) {
          saveAlerta((s) => this.saveResult(s));
        }
        break;

      case "Cambiar Foto de Perfil":
        this.setState({ isVisible: true });
        saveFoto((x) => this.toggle(x));

        break;

      case "Encuestas":
        break;
      case "Login":
        loginAuth((l) => this.ActionResult(l));
        break;
      case "Preguntas":
        if (this.props.datasource.length === this.state.optionSelected.length) {
          this.setState({ isVisible: true });
          GuardarRespuestasInicialesCandidato(this.state.optionSelected, (x) =>
            this.PostularPreguntas(x)
          );
        } else
          notifica(
            "warning",
            "Debe de contestar todas las preguntas",
            "Mensaje"
          );
        break;
      default:
        break;
    }
  }
  PostularPreguntas(data) {
    if (data != null) {
      if (parseInt(data.data.code) === 0) {
        this.postularse();
      } else {
        notifica("warning", data.data.message, "Mensaje");
        this.setState({ isVisible: false });
      }
    }
  }
  async postularse() {
    let request = await postPostularCandidato();
    let cv = window.origin + "/perfil";
    if (Object.keys(request).length > 0) {
      this.setState({ isVisible: false }, () => window.location.replace(cv));
    } else {
      this.setState({ isVisible: false });
    }
  }
  ActionResult(datos) {
    if (datos.code === 0) {
      var dts = datos.data;
      if (dts.length === 1) {
        var bs64 = btoa(unescape(encodeURIComponent(JSON.stringify(dts))));
        sessionStorage.setItem(amb + "_User", bs64);
        getPerfil((p) => this.asignarfoto(p));
        this.validaLogin();
      } else {
        notifica("warning", datos.message, "");
      }
    } else {
      notifica("warning", datos.message, "");
    }
  }

  validaLogin() {
    var usr = getUser();
    if (usr !== undefined) {
      var elm = document.getElementById("btnlopo");
      if (elm) {
        this.setState({ modal: !this.state.modal });

        var btnlopo = document.getElementById("btnlopo2");
        if (btnlopo) btnlopo.click();
      }
      // Manda a generar la postulación
    } else {
      //Se manda a llamar el modal para hacer Login
      this.setState({ moduloModal: "Login" }, () => {
        document.getElementById("BtnMdl").click();
      });
    }
  }
  //función para el resultado de guardar
  saveResult(res) {
    console.clear();
    if (res.code === 0) {
      notifica("info", "Se almacenaron correctamente los datos.", "Ok!");
      document.getElementById("cncmdl").click();
      document.getElementById("GeneraDiv").click();
    } else {
      notifica("error", res.message, "Error");
    }
  }

  render() {
    const spinerConfig = { display: "flex", justifyContent: "center" };
    const { isVisible } = this.state;
    const closeBtn = (
      <button
        className="close"
        id="btnModalClose"
        onClick={() => this.toggle()}
      >
        &times;
      </button>
    );
    return (
      <div>
        <Button
          onClick={() => this.toggle()}
          id="BtnMdl"
          className="Hide_All"
        />
        <label id="lbl_Modal" className="Hide_All" />
        <Modal
          isOpen={this.state.modal}
          toggle={() => this.toggle()}
          className="App-Mod"
          id="Modiv"
          backdrop={"static"}
        >
          <ModalHeader
            close={closeBtn}
            toggle={() => this.toggle()}
            className="App-Mod-Hedr"
          >
            <div className="Mod_Hdr_ttl">
              <label id="lbl_mdl">{this.props.modulo}</label>
              <div id="md_ldr" style={spinerConfig} className="Hide_Half">
                <PropagateLoader size={10} color="#FFFFFF" loading={true} />
              </div>
            </div>
          </ModalHeader>
          <ModalBody>
            <div id="div_frm">
              {(() => {
                let componente = "";
                let idSolicitud = this.state.idSolicitudActual;

                if (
                  idSolicitud > 0 ||
                  this.props.modulo !== "Preguntas Técnicas"
                ) {
                  switch (this.props.modulo) {
                    case "Alertas":
                      return <FrmAlertas info={this.props.datos} />;

                    case "Encuestas":
                      return <FrmEncuestas info={this.props.datos} />;

                    case "Login":
                      return <FrmLogin />;

                    case "Entrevistas de Recursos Humanos":
                      return <FrmRecordVideo tipo={"RH"} />;

                    case "Preguntas Técnicas":
                      return (
                        <FrmRecordVideo tipo={"TC"} idSolicitud={idSolicitud} />
                      );

                    case "CrearCuenta":
                      return <FrmNewUser />;

                    case "Cambiar Foto de Perfil":
                      return <FrmFotoPerfil />;
                    case "Preguntas":
                      return isVisible ? (
                        <center>
                          <Loader
                            type="Circles"
                            color="#F5A796"
                            height="150"
                            width="150"
                          />
                        </center>
                      ) : (
                        <Wizard
                          {...this.props}
                          items={this.state.preguntas}
                          onChange={this.onChange}
                        />
                      );

                    default:
                      return <label>Error al buscar formulario</label>;
                  }
                } else {
                }

                return componente;
              })()}
            </div>
          </ModalBody>
          <ModalFooter className="App-Mod-Ftr">
            {isVisible ? (
              <Loader type="Circles" color="#F5A796" height="50" width="50" />
            ) : (
              <Button
                color="info"
                id="BtnGrdrMdl"
                className="btn_mod_fot"
                onClick={(s) => this.saveData(s)}
              >
                {this.props.btnsv === null ? "Guardar" : this.props.btnsv}
              </Button>
            )}
            {isVisible ? (
              <Loader type="Circles" color="#F5A796" height="50" width="50" />
            ) : (
              <Button
                color="danger"
                onClick={() => this.toggle()}
                id="cncmdl"
                className="btn_mod_fot"
              >
                Cancelar
              </Button>
            )}
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
